<template>
  <div>
    <h2 class="text-subtitle-1 mt-3 mb-3">Gráfico de Rentabilidade</h2>
    <v-card :loading="loading" class="mt-3">
      <v-card-text :class="`pa-0 ${loading ? 'pt-1' : ''}`">
        <apexchart
          v-if="!loading"
          width="100%"
          height="400"
          type="area"
          :options="options"
          :series="series"
        ></apexchart>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import api from '@/services/api';

import pt from '../../../plugins/apex/appex-pt-br.json';

export default {
  props: {
    fundId: String,
    benchmarkId: String,
    benchmarkName: String,
    endDate: String,
    startDate: String,
  },
  data: () => ({
    series: [],
    history: [],
    fundHistoryData: [],
    benchmarkHistory: [],
    dataCategory: [],
    benchmarkHistoryData: [],
    loading: true,
    options: {
      chart: {
        locales: [pt],
        defaultLocale: 'pt-br',
        animations: {
          enabled: false,
          animateGradually: {
            enabled: false,
          },
          dynamicAnimation: {
            enabled: false,
          },
        },
        zoom: {
          type: 'x',
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        line: {
          curve: 'smooth',
        },
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
        style: 'full',
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          // opacityFrom: 0.5,
          // opacityTo: 0,
          // stops: [0, 90, 100],
        },
      },
      stroke: {
        show: true,
        curve: 'straight',
        // lineCap: 'butt',
        // colors: undefined,
        width: 2,
      },
      yaxis: {
        title: {
          text: '',
        },
        labels: {
          formatter: (val) => parseFloat(val).toFixed(0),
        },
      },
      xaxis: {
        type: 'datetime',
        labels: {
          datetimeFormatter: {
            year: 'MM/yyyy',
            month: 'MM/yyyy',
            day: 'dd/MM/yyyy',
            hour: 'HH:mm',
          },
        },
      },
      tooltip: {
        shared: true,
        x: {
          show: true,
          format: 'dd/MM/yyyy',
          // format: 'dd/MM/yyyy HH:mm',
          formatter: undefined,
        },
        y: {
          formatter(val) {
            return `${val.toFixed(2)}%`;
          },
        },
      },
    },
  }),
  watch: {
    fundId() {
      this.getData();
    },
    startDate() {
      this.getData();
    },
    endDate() {
      this.getData();
    },
  },
  methods: {
    updateChart(fundData, benchData) {
      this.series = [
        {
          data: fundData,
          name: 'Fundo',
        },
        {
          data: benchData,
          name: this.benchmarkName,
        },
      ];
    },
    async getData() {
      try {
        if (!this.fundId && !this.benchmarkId) return;
        this.loading = true;

        // Get Fund information
        const {
          data: { fundReturns, benchReturns },
        } = await api.funds.returnsRelativeById(this.fundId, {
          params: {
            endDate: this.endDate,
            startDate: this.startDate,
          },
        });

        const fundReturnsMap = fundReturns.map((input) => ({ x: input.date, y: input.value }));
        const benchReturnsMap = benchReturns.map((input) => ({ x: input.date, y: input.value }));

        // Update the chart
        this.updateChart(fundReturnsMap, benchReturnsMap);
        this.loading = false;
      } catch (error) {
        throw Error(error);
      }
    },
  },
  async created() {
    await this.getData();
  },
};
</script>
